/**
 * Created by andreyna on 8/16/2017.
 */
export const FP_INDICATOR_CLASSES = {
    COMPONENT: 'cgp-fp-indicator-component',
    ICON: 'cgp-fp-indicator',
    ACTIVE: 'cgp-fp-indicator-active',
    STATE_TEMPLATE: 'cgp-fp-indicator-state-',
    STATE_DISABLED: 'cgp-fp-indicator-state-disabled',
    STATE_ENABLED: 'cgp-fp-indicator-state-enabled',
    ICON_ENABLED_BACKGROUND: 'cgp-theme-property-icons-fp-enabled',
    ICON_SELECTED_BACKGROUND: 'cgp-theme-property-icons-fp-selected',
    ICON_DISABLED_BACKGROUND: 'cgp-theme-property-icons-fp-disabled',
}

export const FREE_PLAY_FILTER_CONSTRAINTS = {
    FREE_PLAY_EXIST: 'exist',
    NEW: 'new',
    CONTAINS_GAME: 'game'
}

export const DISPLAY_CONSTRAINT = FREE_PLAY_FILTER_CONSTRAINTS.FREE_PLAY_EXIST;
